(function($){
  $.fn.sbBoToggleFilter = function()
  {
    var $this      = this;

    // Home-made toogle filter disabled prop depending on a switcher
    $this.on('change', 'input[type=checkbox]', function(e) {
      var $this = $(this)
      var checked = $this.prop("checked");
      var $filterContainer = $this.closest('.filter-container, .form-group');
      if(checked) {
        $filterContainer.removeClass('filter-disabled disabled').addClass('filter-enabled');
      } else {
        $filterContainer.removeClass('filter-enabled').addClass('filter-disabled disabled');
      }
      $filterContainer.find('.filter').find('input, select, textarea').prop('disabled', !checked).first().focus();
    });

    return this;
  };
})(jQuery);

(function($){
  $.fn.sbBoManageTableRadioSelectRows = function()
  {
    var $this      = this;

    $this.on('click', 'tr.radio-select-row', function(e) {
      var $checkedRadioInputTr = $(this);

      if($(e.target).hasClass('open-modal')) return false;

      if(!$checkedRadioInputTr.hasClass("success")) {
        var $checkedRadioInput    = $checkedRadioInputTr.find("input[type='radio']").first();
        var $otherRadioInputs     = $checkedRadioInputTr.closest("table").find("input[name='" + $checkedRadioInput.attr("name") + "']").not($checkedRadioInput);
        var $otherRadioInputsTr   = $otherRadioInputs.closest("tr");

        $checkedRadioInput.parent("span").addClass("checked");
        $checkedRadioInputTr.addClass("success");
        $checkedRadioInputTr.find('.disable-when-tr-unselected').prop("disabled", false);
        $checkedRadioInputTr.find("input.autofocus").first().select();

        $otherRadioInputs.parent("span").removeClass("checked");
        $otherRadioInputsTr.removeClass("success");
        $otherRadioInputsTr.find('.disable-when-tr-unselected').prop("disabled", true);

        // Do it at the end to make form submit-on-change work
        $otherRadioInputs.prop("checked", false);
        $checkedRadioInput.prop("checked", true).change();
      }
    });

    $this.on('click', 'tr.radio-select-row input, tr.radio-select-row textarea', function(e) {
      if($(this).attr("type") != "radio") {
        e.stopPropagation();
      }
    });

    return this;
  };
})(jQuery);

(function($){
  $.fn.sbBoManageTableCheckboxSelectRows = function()
  {
    var $this      = this;

    $this.on('click', 'tr.checkbox-select-row', function(e) {
      var $checkboxInputTr = $(this);
      var $checkboxInput = $checkboxInputTr.find("input[type='checkbox']").first();
      var $targetedTrs = $checkboxInputTr.closest("table").find("tr" + $checkboxInputTr.data("checkbox-target"));

      if($checkboxInput.prop("checked")) {
        $checkboxInput.parent("span").removeClass("checked");
        $checkboxInputTr.removeClass("success");
        $checkboxInputTr.find('.disable-when-tr-unselected').prop("disabled", true);
        if($checkboxInputTr.data("checkbox-target")) {
          $targetedTrs.hide();
        }
        $checkboxInput.prop("checked", false).change();
      } else {
        $checkboxInput.parent("span").addClass("checked");
        $checkboxInputTr.addClass("success");
        $checkboxInputTr.find('.disable-when-tr-unselected').prop("disabled", false);
        $checkboxInputTr.find("input.autofocus").first().select();
        if($checkboxInputTr.data("checkbox-target")) {
          $targetedTrs.show();
        }
        $checkboxInput.prop("checked", true).change();
      }
    });

    $this.on('click', 'tr.checkbox-select-row input, tr.checkbox-select-row textarea', function(e) {
      if($(this).attr("type") != "checkbox") {
        e.stopPropagation();
      }
    });

    return this;
  };
})(jQuery);


$(function() {

	// Styled input file
	$(".file-styled").uniform({
		fileButtonClass: 'action btn btn-default'
	});

  // Checkboxes/radios (Uniform)
  $(".styled, .multiselect-container input").uniform({
      radioClass: 'choice'
  });

  $('input.control-success[type=checkbox]').uniform({
    radioClass: 'choice',
    wrapperClass: 'border-success-600 text-success-800'
  })

  $('input.control-default[type=checkbox]').uniform({
    radioClass: 'choice',
    wrapperClass: 'border-default text-default'
  })

  $('.form-group label.toggle-filter').each(function() { $(this).sbBoToggleFilter() });

  $('div.checkbox.with-opacity').each(function(){ if(!$(this).find('input').is(':checked')) $(this).addClass('unchecked') })

  $('div.checkbox.with-opacity').on('change', 'input[type=checkbox]', function(){
	  var $this = $(this);
	  var $checkBoxContainer = $this.closest('div.checkbox');

	  ($this.is(':checked')) ? $checkBoxContainer.removeClass('unchecked') : $checkBoxContainer.addClass('unchecked');
  });

  $('.shortcut_checker').on('click', function(){
	  var $this = $(this);
	  var action = $this.data('action');
	  var $checkboxesContainer = $($this.data('checkboxes-container'));

	  switch(action) {
		  case 'check_all':
		  	$checkboxesContainer.find('input[type=checkbox]').prop('checked', true).trigger('change').uniform().update();
		  break;
		  case 'uncheck_all':
		  	$checkboxesContainer.find('input[type=checkbox]').prop('checked', false).trigger('change').uniform().update();
		  break;
	  }

	  return false;
  });

  $('.table').on('change', 'tr.switch-select-row input[type=checkbox]', function(e) {
    var $this = $(this);
    var checked = $this.prop("checked");
    var $row = $this.closest('tr');
    if(checked) {
      $row.removeClass('disabled');
    } else {
      $row.addClass('disabled');
    }
  });

  $('.table').each(function() {
    $(this).sbBoManageTableRadioSelectRows();
    $(this).sbBoManageTableCheckboxSelectRows()
  });

  $('.submit-on-change').on('change', function() {
    if(!$(this).hasClass('no-loader')){
      backoffice.loader.start();
    }
    $(this).closest('form').submit();
  });

  $('.tags-input').tagsinput();
  $('.tags-input').on('itemRemoved', function(items){
    var $option = $(items.currentTarget).find('option').filter(function(){
      if($(this).val() == items.item) return $(this);
    })

    $option.remove();
  });

  $('.pickatime').pickatime();

  $('input.toggle-target').on('change', function () {
    var $input          = $(this);
    var targetsSelector = $input.attr('data-toggle-target');

    if(targetsSelector.length > 0) {
      var $targets      = $(targetsSelector);

      if($input.prop("checked")) {
        $targets.fadeIn(100);
      } else {
        $targets.fadeOut(100);
      }
    }
  });

  $('.range-field-wrapper input[type="range"]').on('input', function(event) {
    var $input      = $(this);
    var $wrapper    = $input.closest('.range-field-wrapper');
    var $valueLabel = $wrapper.find('.range-field-value');
    $valueLabel.text($input.val());
  });

  autosize($('.autosize'));

  $('input[type=checkbox].select-all-checkboxes').each(function(){
    new backoffice.multipleCheckbox($(this));
  });

  CkeditorInlineModule.init();

  $('.form-submit-ajax').each(function(){
    new backoffice.formSubmitAjax($(this));
  });

  $('.slider').each(function() {
    $(this).ionRangeSlider({
      min: $(this).data('min') || 0,
      max: $(this).data('max') || 10,
      step: $(this).data('step') || 1,
      from: $(this).val() || 0
    });
  });

  $("form").on("form--nested:add", function() {
    $('.slider:not(.irs-hidden-input)').each(function() {
      $(this).ionRangeSlider({
        min: $(this).data('min') || 0,
        max: $(this).data('max') || 10,
        step: $(this).data('step') || 1,
        from: $(this).val() || 0
      });
    });
  });
});
